module.exports = __webpack_public_path__ + "img/nimtu_loader.be05ed9b.gif";